/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetPortfolioQueryResult } from '../../models/get-portfolio-query-result';

export interface ApiPortfolioGetPortfolioGet$Plain$Params {
  Id: string;
}

export function apiPortfolioGetPortfolioGet$Plain(http: HttpClient, rootUrl: string, params: ApiPortfolioGetPortfolioGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetPortfolioQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiPortfolioGetPortfolioGet$Plain.PATH, 'get');
  if (params) {
    rb.query('Id', params.Id, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetPortfolioQueryResult>;
    })
  );
}

apiPortfolioGetPortfolioGet$Plain.PATH = '/api/Portfolio/GetPortfolio';
